export default {

    // 缓存用户信息
    setPreviousRoute(context, previousRoute){
        context.commit('setPreviousRoute', previousRoute)
    },
}